import {useCallback} from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {IGameContextViewModel} from "../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {GameNavBarItemMobileComponent} from "../game-nav-bar-item.mobile.component";
import {DialogButtonClickHandleResultEnum} from "../../../../services/dialog/dialog.service.interface";

interface IGameNavBarItemComponentProps {
    gameContext: IGameContextViewModel;
}

export const ExitGameNavBarMobileComponent: React.FC<IGameNavBarItemComponentProps> = observer((props) => {
    const services = useServices();

    const _sentenceCase = useCallback((str: string): string => {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }, []);

    const _exitGame = useCallback(() => {
        services.analytics.sendOrbitUserFlowEvent("Navigation", "ExitGame", 'InGameBottomNavBar');
        services.dialog.showSimpleTextModal({
            title: services.translation.translate('EXIT_GAME_POPUP_TITLE'),
            text: services.translation.translate('EXIT_GAME_POPUP_TEXT'),
            hideCloseButton: true,
            buttons: [
                {
                    text: services.translation.translate('OK'),
                    buttonPreset: 'primary',
                    onClick: async () => {
                        services.analytics.sendOrbitUserFlowEvent("InGamePopUp", "Yes", 'ExitGame');
                        props.gameContext.controller.closeGame({shouldSuggestNextGame: false});
                        return DialogButtonClickHandleResultEnum.CloseDialogAndContinue
                    }
                },
                {
                    text: services.translation.translate('CANCEL'),
                    buttonPreset: 'info',
                    onClick: async () => {
                        services.analytics.sendOrbitUserFlowEvent("InGamePopUp", "No", 'ExitGame');
                        return DialogButtonClickHandleResultEnum.CloseDialogAndContinue
                    }
                }
            ]
        })
    }, [props.gameContext, services.dialog, services.translation, services.analytics]);
    
    const ExitIcon = services.theme.currentTheme.icons.leaveIcon;

    return <GameNavBarItemMobileComponent Icon={ExitIcon} text={_sentenceCase(services.translation.translate("EXIT"))} onClick={_exitGame} />;
});
